/* ==========================================================
 * Tabs
 * ========================================================== */
import BaseFeature from '../../foundation/base/base';

class Tabs extends BaseFeature {
	constructor(element) {
		super(element);
		this.el = element;
		this.initDomCache();

		this.tabs = this.el.querySelectorAll('[data-tab-target]');
		[this.defaultTab] = this.tabs; // select first tab

		// Get the default tab and open it
		this.updateContent(this.defaultTab);
		this.initEvents();
	}

	initEvents() {
		this.tabs.forEach((item) => {
			this.addEventListener(item, 'click', (e) => {
				e.preventDefault();
				this.updateContent(item);
			});
		});
	}

	updateContent(item) {
		if (this.activeTab) {
			this.activeTab.classList.remove('o-tabs__toggle--active');
		}

		this.activeTab = item;
		this.activeTab.classList.add('o-tabs__toggle--active');

		if (this.activeSection) {
			this.activeSection.classList.remove('o-tabs__section--active');
		}

		this.activeSection = this.el.querySelector('[data-tab-section = "' + item.getAttribute('data-tab-target') + '"]');
		this.activeSection.classList.add('o-tabs__section--active');
	}
}

export default Tabs;
